module.exports = __webpack_public_path__ + "img/caas2-m@1.fb7d0a6c.webp";